import Vue from 'vue'
import Router from 'vue-router'
import AprilTag from '@/components/AprilTag/AprilTag'
import AprilTagIndex from '@/components/AprilTag/AprilTagIndex'
import AprilTagDownload from '@/components/AprilTag/AprilTagDownload'
import AprilTagDownloadExpand from '@/components/AprilTag/AprilTagExpandDownload'
import AprilTagQuanti from '@/components/AprilTag/AprilTagQuanti'
import Page404 from  '@/components/Page404'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      /* 現状AprilTagだけなので、AprilTagに遷移 */
      path: '/',
      redirect: '/AprilTag'
    },
    {
      path: '/AprilTag',
      name: 'AprilTag',
      component: AprilTag,
      children: [
        {
          path: '',
          name: 'AprilTag Solution',
          component: AprilTagIndex
        },
        {
          path: 'Quanti',
          name: 'Quanti',
          component: AprilTagQuanti,
        },
        {
          path: 'download',
          name: 'Download',
          component: AprilTagDownload,
        },
        {
          path: 'Expand/download',
          name: 'ExpandAprilTagDownload',
          component: AprilTagDownloadExpand,
        }
      ]
    },
    {
      // not found handler
      path: '*',
      name: 'Page404',
      component: Page404,
    }
  ],
  mode: 'history',
  // aタグのアンカー機能を有効化
  scrollBehavior: function(to, from, savedPosition) {
    if (to.hash) {
        return {selector: to.hash}
    } else {
        return { x: 0, y: 0 }
    }
  }
})

export default router


// WEBPACK FOOTER //
// ./src/router/router.js